<template>
  <div id="CustomerPurchaseOrderList">
    <div :class="`loader${loaderClass}`" v-show="loading"></div>
    <template v-if="cantAccessPage === true">
      <div class="admin-page-content customer-detail">
        <!-- Button for Clear Cache -->
        <div class="btn-groups text-right">
          <clear-cache-data :pageKey="[pageKey]"></clear-cache-data>
          <router-link v-if="addPurchaseOrder && $parent.type == ''" class="btn btn-primary"
                       v-bind:to="{ name: 'CustomerPurchaseOrderCreate', params: { flag: 'fromList' } }">
            <i class="fp-add"></i> Add
          </router-link>
          <router-link v-if="addPurchaseOrder && $parent.type == 'contract'" class="btn btn-primary"
                       v-bind:to="{ name: 'CustomerPurchaseOrderCreate', query: { type: 'contract' } }">
            <i class="fp-add"></i> Add
          </router-link>
          <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportCheck()">
            <i class="fp-export"></i> Export
          </a>
        </div>
        <data-table-filter-config :moduleName="'customerListPurchaseOrders'" ref="filterCustPO"
                                  @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
        <div class="data-table bg-white overflow-hidden">
          <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in
            process. batch no. is {{ batchNum }}.
            <router-link class="color-blue"
                         v-bind:to="{ name: 'BatchList' }" target="_blank" @click.native="batchProcess = 0"> Click
              Here
            </router-link>
            to check file status!
          </p>
          <section class="data-table bg-white">
            <custom-pagination :page-changed="onPageChange" :per-page-changed="onPerPageChange"
                               :moduleName="'customerListPurchaseOrders'" :position="'top'">
            </custom-pagination>
            <vue-good-table ref="customerlistPurchaseOrder" mode="remote" title="Order History"
                            @on-page-change="onPageChange" @on-selected-rows-change="selectionChanged"
                            @on-column-filter="onColumnFilter" @on-per-page-change="onPerPageChange"
                            @on-sort-change="onSortChange" @on-select-all="onSelectAll" :totalRows="totalRecords"
                            :columns="userColumns" :rows="rows" :pagination-options="{
                                enabled: false,
                                position: 'both',
                                perPage: perPage,
                                perPageDropdown: dropDownPerPage,
                                dropdownAllowAll: false,
                            }" :select-options="{
                                enabled: deletePurchaseOrder,
                                selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                selectionInfoClass: 'custom-class',
                                selectionText: 'rows selected',
                                clearSelectionText: 'clear',
                            }" :search-options="{
                                enabled: false,
                            }">

              <template slot="table-row" slot-scope="props" v-for="(row, key) in rows">
                <div :key="key">
                  <div v-if="props.column.field == 'action'">
                    <a title="View Log" v-on:click.prevent="goToGetLogInfo(props.row.id)"
                       class="fp-log-file-format" href="javascript:void(0)"
                       style="font-size: 15px;"></a>
                    <template v-if="props.row.allCommentSeen">
                      <svg style="margin-top: -5px;" xmlns="http://www.w3.org/2000/svg"
                           fill="none" viewBox="0 0 24 24" stroke-width="1" stroke="currentColor"
                           width="16" height="16">
                        <title>No New Comment</title>
                        <path stroke-linecap="round" stroke-linejoin="round"
                              d="M21.75 9v.906a2.25 2.25 0 0 1-1.183 1.981l-6.478 3.488M2.25 9v.906a2.25 2.25 0 0 0 1.183 1.981l6.478 3.488m8.839 2.51-4.66-2.51m0 0-1.023-.55a2.25 2.25 0 0 0-2.134 0l-1.022.55m0 0-4.661 2.51m16.5 1.615a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V8.844a2.25 2.25 0 0 1 1.183-1.981l7.5-4.039a2.25 2.25 0 0 1 2.134 0l7.5 4.039a2.25 2.25 0 0 1 1.183 1.98V19.5Z"/>
                      </svg>
                    </template>
                    <template v-else>
                      <svg style="margin-top: -5px;stroke: var(--color-orange-rizon);"
                           xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                           stroke-width="2" width="18" height="18">
                        <title>New Comment(s)</title>
                        <path stroke-linecap="round" stroke-linejoin="round"
                              d="M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75"/>
                      </svg>
                    </template>
                  </div>
                  <div v-else-if="props.column.field == 'orderNumber'">
                    <router-link title="Edit Part Order" class="color-blue"
                                 v-bind:to="{ name: 'CustomerPurchaseOrderEdit', params: { id: props.row.id } }">
                      {{ props.row.orderNumber }}
                    </router-link>
                  </div>
                  <div v-else-if="
                                        props.column.field == 'invoice_number'
                                        ||
                                        props.column.field == 'invoice_date'
                                        ||
                                        props.column.field == 'tracking_number'
                                        ||
                                        props.column.field == 'ship_date'
                                    ">
                    <li v-for="billingRecord in props.row.billingRecords">
                      <template v-if="props.column.field == 'invoice_number'">
                        {{ billingRecord.invoice_number }}
                      </template>
                      <template v-if="props.column.field == 'invoice_date'">
                        {{ billingRecord.invoice_date }}
                      </template>
                      <template v-if="props.column.field == 'tracking_number'">
                        {{ billingRecord.tracking_number }}
                      </template>
                      <template v-if="props.column.field == 'ship_date'">
                        {{ billingRecord.ship_date }}
                      </template>
                    </li>
                  </div>

                  <div v-else>
                    {{ props.formattedRow[props.column.field] }}
                  </div>
                </div>
              </template>

              <div slot="selected-row-actions">
                <button v-if="deletePurchaseOrder" id="deletePurchaseOrderTypeBtn"
                        v-on:click.prevent="PurchaseOrderDelete" class="btn btn-danger">Delete
                </button>
              </div>
            </vue-good-table>
            <custom-pagination :page-changed="onPageChange" :per-page-changed="onPerPageChange">
            </custom-pagination>
          </section>
        </div>
      </div>
      <audit-log-popup :logs="logs" :popUpTitle="popUpTitle"></audit-log-popup>
    </template>
    <template v-else-if="cantAccessPage === false">
      <div class="container-fluid">
        <div class="bg-white text-center">
          <h1>
            Oops!</h1>
          <h2>
            403 </h2>
          <div class="error-details">
            Sorry!, You don't have permission to access this page.
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <loading-content></loading-content>
    </template>
  </div>
</template>

<script>
import EventBus from "./event-bus";
import Vue from "vue";
import {commonMixins} from '../mixins/commonMixins';
import {dataTableMixins} from '../mixins/dataTableMixins';

export default {
  name: "CustomerPurchaseOrderList",
  mixins: [commonMixins, dataTableMixins],
  props: {
    customerPurchaseVal: {
      type: String,
      required: false,
      default: undefined
    },
    vendorPurchaseStatus: {
      type: String,
      required: false,
      default: undefined
    },
  },
  data: () => ({
    canCreateWorkOrder: false,
    canCreateAssetSale: false,
    firstLoad: 0,
    permissions: [],
    cantAccessPage: '',
    purchase_order_value: true,
    userColumns: [],
    columns: [
      {
        label: 'Actions',
        field: 'action',
        sortable: false,
      },
      {
        label: 'Order Number',
        field: 'orderNumber',
        fpFieldType: "text",
        filterable: true,
        hidden: false,
      },
      {
        label: 'Sale ID',
        field: 'sale_id',
        fpFieldType: "text",
        filterable: true,
        hidden: false,
      },
      {
        label: 'Order Date',
        field: 'order_date',
        fpFieldType: "date",
        filterable: true,
        hidden: false,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "MM/DD/YYYY", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: "enter" //only trigger on enter not on keyup
        },
      },
      {
        label: 'Dealer',
        field: 'dealer',
        fpFieldType: "text",
        filterable: true,
        hidden: false,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Dealer", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: "enter" //only trigger on enter not on keyup
        },
      },
      {
        label: 'Dealer PO#',
        field: 'po_no',
        fpFieldType: "text",
        filterable: true,
        hidden: false,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "# PO", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: "enter" //only trigger on enter not on keyup
        },
      },
      {
        label: 'Order Status',
        field: 'status',
        fpFieldType: "option",
        filterable: true,
        hidden: false,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "All", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          filterDropdownItems: [
            'Backorder',
            'Canceled',
            'Draft',
            'In-Process',
            'Invoiced',
            'Partially Shipped',
            'Requested-For-Cancellation',
            'Shipped',
            'Submission-Failed',
            'Submitted'
          ],
          trigger: "enter" //only trigger on enter not on keyup
        },
      },
      {
        label: 'Dealer RO#',
        field: 'repair_order',
        fpFieldType: "text",
        filterable: true,
        hidden: false,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "# PO", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: "enter" //only trigger on enter not on keyup
        },
      },
      {
        label: 'VIN',
        field: 'vin',
        fpFieldType: "text",
        filterable: true,
        hidden: false,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "# PO", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: "enter" //only trigger on enter not on keyup
        },
      },
      {
        label: 'Invoice Number',
        field: 'invoice_number',
        fpFieldType: "text",
        filterable: true,
        hidden: false,
        sortable: false,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "# PO", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: "enter" //only trigger on enter not on keyup
        },
      },
      {
        label: 'Invoice Date',
        field: 'invoice_date',
        fpFieldType: "date",
        filterable: true,
        hidden: false,
        sortable: false,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "MM/DD/YYYY", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: "enter" //only trigger on enter not on keyup
        },
      },
      {
        label: 'Tracking Number',
        field: 'tracking_number',
        fpFieldType: "text",
        filterable: true,
        hidden: false,
        sortable: false,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "# PO", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: "enter" //only trigger on enter not on keyup
        },
      },
      {
        label: 'Ship Date',
        field: 'ship_date',
        fpFieldType: "date",
        filterable: true,
        hidden: false,
        sortable: false,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "MM/DD/YYYY", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: "enter" //only trigger on enter not on keyup
        },
      },
      {
        label: 'Order Submitted By',
        field: 'created_by',
        fpFieldType: "text",
        filterable: true,
        hidden: false,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "# PO", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: "enter" //only trigger on enter not on keyup
        },
      },
    ],
    rows: [],
    totalRecords: 0,
    asset_value: false,
    loading: false,
    permit_value: false,
    addPurchaseOrder: false,
    updatePurchaseOrder: false,
    assetId: "",
    selectedFile: "",
    canViewPurchaseOrder: false,
    canViewWorkOrder: false,
    deletePurchaseOrder: false,
    flag: '',
    action: '',
    pageKey: "_customer_po_list",
    fromUrl: "",
    batchProcess: 0,
    batchNum: "",
    velocity_env: process.env.NODE_ENV,
    popUpTitle: 'Parts Order Activity Log Details',
    logs: []
  }),
  watch: {
    //check permission change
    permissions: function (permissions) {
      var self = this;
      if (permissions.length > 0) {
        for (var i = 0; i < permissions.length; i++) {
          // ev permisions
          if (self.velocity_env == "velev" || self.velocity_env == "velev_test") {
            if (permissions[i].name == 'ev_list_part_order') {
              self.cantAccessPage = true;
            }
            if (permissions[i].name == 'ev_add_part_order') {
              self.addPurchaseOrder = true;
              self.updatePurchaseOrder = true;
            }
            if (permissions[i].name == 'ev_delete_part_order') {
              self.addPurchaseOrder = true;
              self.canViewPurchaseOrder = true;
            }
            if (permissions[i].name == 'ev_view_part_order') {
              self.deletePurchaseOrder = true;
            }
          } else {
            if (permissions[i].name == 'list_customer_purchase_order') {
              self.cantAccessPage = true;
            }
            if (permissions[i].name == 'add_customer_purchase_order') {
              self.addPurchaseOrder = true;
              self.updatePurchaseOrder = true;
            }
            if (permissions[i].name == 'view_customer_purchase_order') {
              self.addPurchaseOrder = true;
              self.canViewPurchaseOrder = true;
            }
            if (permissions[i].name == 'delete_customer_purchase_order') {
              self.deletePurchaseOrder = true;
            }
            if (permissions[i].name == 'can_create_work_order_from_po') {
              self.canCreateWorkOrder = true;
            }
            if (permissions[i].name == 'view_work_order') {
              self.canViewWorkOrder = true;
            }
          }
        }
      }

    },
    vendorPurchaseStatus(changedVal) {
      if (
        changedVal == 'submitted'
        ||
        changedVal == 'canceled'
        ||
        changedVal == 'draft'
        ||
        changedVal == 'all'
      ) {
        this.loadList();
      }
    }
  },
  created: function () {

  },
  mounted: function () {
    var self = this;
    self.fromUrl = btoa(window.location.pathname + window.location.search);
    self.getPermissions();

    if (self.velocity_env == "velev" || self.velocity_env == "velev_test") {
      for (let column of this.columns) {
        if (column.field == 'customer' || column.field == 'effective_to'
          || column.field == 'effective_from') {
          this.$set(column, 'hidden', true);
        }
        if (column.field == 'delivery_date') {
          this.$set(column, 'label', "Invoice Date");
        }
      }
    } else {
      for (let column of this.columns) {
        if (column.field == 'dealer') {
          this.$set(column, 'hidden', true);
        }
      }
    }
  },
  methods: {
    cancelAll: function (cancelAll) {
      this.$refs.customerlistPurchaseOrder.unselectAllInternal();
    },
    selectionChanged(param) {
      var self = this;
      self.serverParams.selectedAll = false;
      if (param.selectedRows.length == 100) {
        EventBus.$emit('clear-selection', false);
      } else {
        EventBus.$emit('clear-all-flags', false);
      }
      if (param.selectedRows.length > 1) {
        self.canCreateAssetSale = false;
      } else {
        self.canCreateAssetSale = true;
      }
      return;
    },
    loadList() {
      var self = this;

      var selectedRows = [];
      var customerListPO = this.$refs['customerlistPurchaseOrder'];

      if (
        customerListPO
        &&
        customerListPO.selectedRows
        &&
        customerListPO.selectedRows.length > 0
      ) {
        var data = customerListPO.selectedRows;

        for (var i = 0; i < data.length; i++) {
          selectedRows.push(data[i].id);
        }
      }

      self.loading = true;

      var fields = {
        page: self.serverParams.page,
        perPage: self.serverParams.perPage,
        filters: self.serverParams.columnFilters,
        sort: self.serverParams.sort,
        id: selectedRows,
        action: self.action,
        all: self.serverParams.selectedAll,
        type: self.$parent.type,
        status: self.vendorPurchaseStatus
      };
      self.firstLoad = 1;
      $.ajax({
        url: process.env.ROOT_API + "/customer-purchase-order/list",
        type: "POST",
        data: fields,
        headers: this.ajxHeaders,
        dataType: "json",
        success: function (data) {
          self.loading = false;

          if (data.status == "success") {
            if (self.action == "delete") {

              self.action = "";
              $("#deletePurchaseOrderTypeBtn").val("Delete");

              self.$refs.filterCustPO.clearSelectAll();
              if (data.code == '200') {

                self.loadList();
              }

              EventBus.$emit('clear-all-flags', false);  //hide alert of selection

            } else if (self.action == "export" || self.action == "export_queue") {
              if (data.code == "201") {
                alert(data.message);
              } else {
                if (self.action == "export") {
                  self.excel = data.content.web;
                  var save = document.createElement("a");
                  save.href = self.excel;
                  save.download = data.content.web;
                  save.target = "_blank";

                  document.body.appendChild(save);
                  save.click();
                  document.body.removeChild(save);

                } else {

                  self.batchProcess = 1;
                  self.batchNum = data.content;
                }
              }
              self.action = "list";
              self.loadList();
            } else {
              self.rows = data.content.row;
              self.totalRecords = data.content.totalRecords;
              // EventBus.$emit("customerpurchaseOrderCount", data.content.pocount);
              self.filteredFlag = false;
            }
          }
        },
        error: function (jqXHR, exception) {
          self.loading = false;
          self.generateStatusCodeMessage(jqXHR, false, 'customer-po-list');
        }
      });
    },
    PurchaseOrderDelete() {
      var self = this;
      self.$swal({
        title: 'Are you sure that you want to delete this Customer Purchase Order?',
        type: 'info',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        showCloseButton: false,
        showLoaderOnConfirm: true
      }).then((result) => {
        if (result.value) {
          self.loading = true;
          $("#deletePurchaseOrderTypeBtn").val("Deleting ...");
          self.action = "delete";
          self.loadList();
        } else {
          console.log("no");
        }
      });
    },

    workOrderCreate() {

      var self = this;

      if (this.$refs['customerlistPurchaseOrder'].selectedRows.length != 1) {
        self.$swal('', "Kindly choose only one purchase order.", 'info');
        return;
      }

      if (this.$refs['customerlistPurchaseOrder'].selectedRows[0].work_order_no != '-') {
        self.$swal('', "Work Order has already been created.", 'info');
        return;
      }

      if (confirm('Do you want to create Work Order from selected Purchase order? ')) {

        this.$router.push({
          name: 'WorkOrderCreate',
          params: {
            purchaseOrderId: this.$refs['customerlistPurchaseOrder'].selectedRows[0].id,
            redirectFrom: 'CustomerPurchaseOrderList'
          }
        })
      }
    },
    exportCheck: function () {
      var count = 0;
      var actionFlag = "";
      var data = this.$refs['customerlistPurchaseOrder'].selectedRows;
      count = data.length;
      if (this.serverParams.selectedAll == true) {
        actionFlag = "";
      } else if (count != 0 && count <= 100) {
        actionFlag = "export";
      }
      this.exportReports(actionFlag);
    },
    assetSaleCreate() {
      var self = this;
      self.$swal({
        title: "",
        text: "Are you sure you want to create asset sale?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Ok",
        cancelButtonText: "Cancel",
        showCloseButton: true,
        showLoaderOnConfirm: true
      }).then(result => {
        if (result.value) {
          var customerPoId = this.$refs['customerlistPurchaseOrder'].selectedRows[0]['id'];
          self.$router.push({name: 'AssetSaleCreate', params: {customerPoId}});
        } else if (result.dismiss) {
          self.recalls = '';
          return;
        }
      });
    },
    goToGetLogInfo(logId) {
      var logFlag = 'PARTS_ORDER_AUDIT';

      this.getLogInfo(logId, logFlag);
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/CustomerPurchaseOrderList.vue